import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { ProductConfiguration } from '../common/constants';
import EasyContextHandler from '../components/context/EasyContextHandler';
import { MsalProvider } from "@azure/msal-react";
import { useEffect, useState } from "react";

const msalConfigurationCenterConfig: Configuration = {
  auth: {
    clientId: ProductConfiguration.EasyCallReport.Admin.ApplicationId,
    redirectUri: ProductConfiguration.EasyCallReport.Admin.RedirectUrl,
    authority: ProductConfiguration.EasyCallReport.Admin.Authority
  },
};

const ecrPca = new PublicClientApplication(msalConfigurationCenterConfig);

const EasyCallReportAuthenticatedLayout = () => {
  return (
    <MsalProvider instance={ecrPca}>
      <EasyContextHandler authScopes={ProductConfiguration.EasyCallReport.Admin.Scopes}/>
    </MsalProvider>
  )
}

export default EasyCallReportAuthenticatedLayout
